'use client';
import React from 'react';

import { ReplyLink } from './Comment.styled';
import { useCommentsSectionContext } from '@/ui/containers/CommentsSection/CommentsSectionContext';
import { WAIT_FOR_INVALIDATION_MS } from '@/ui/containers/CommentsSection/constants';
import { log } from '@/utils/logger';
import request from '@/utils/queryData/rest/clientRequest';

/**
 * @todo refactor - duplicate
 */
function decodeHTMLString(htmlString: string): string {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');
  return doc.documentElement.textContent || '';
}

export default function DeleteCommentButton({ commentId }) {
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [error, setError] = React.useState(null);

  const { reloadComments } = useCommentsSectionContext();

  const deleteComment = React.useCallback(() => {
    const body = { status: 'trash' };

    setIsSubmitting(true);

    new request('commentActionFrontend')
      .post({
        id: commentId,
        body,
      })
      .then(_data => {
        setTimeout(() => {
          // wait for invalidation to finish
          reloadComments();
        }, WAIT_FOR_INVALIDATION_MS);
        setError(null);
      })
      .catch(error => {
        const errorMessage = error?.message;
        try {
          if (typeof errorMessage === 'string') {
            const parsedError = JSON.parse(errorMessage) || '';
            const parsedErrorMessage = decodeHTMLString(parsedError?.message);
            setError(parsedErrorMessage || parsedError);
          }
        } catch {
          log.error('AddCommentForm: Error parsing error message');
          setError(errorMessage?.message || errorMessage);
        }
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  }, [commentId, reloadComments]);

  React.useEffect(() => {
    if (error) {
      alert(error);
    }
  }, [error]);

  if (isSubmitting) {
    return <span>Deleting...</span>;
  }

  return (
    <ReplyLink
      onClick={() => {
        if (window.confirm('Are you sure you want to delete this comment?')) {
          deleteComment();
        }
      }}
    >
      Delete
    </ReplyLink>
  );
}
